import { render, staticRenderFns } from "./Supplement.vue?vue&type=template&id=5e27637f&scoped=true&"
import script from "./Supplement.vue?vue&type=script&lang=js&"
export * from "./Supplement.vue?vue&type=script&lang=js&"
import style0 from "./Supplement.vue?vue&type=style&index=0&id=5e27637f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27637f",
  null
  
)

export default component.exports